<template>
  <div class="merge">
    <el-dialog title="合并" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
      <div class="container">
        <el-form
          inline
          :model="mergeData"
          :rules="mergeDataRules"
          ref="mergeData"
          label-width="60px"
        >
          <el-form-item label="原编码" prop="productDetailCodeOld">
            <el-input v-model="mergeData.productDetailCodeOld" clearable maxlength="32"></el-input>
          </el-form-item>
          <el-form-item label="改为" prop="productDetailCodeNew">
            <el-input v-model="mergeData.productDetailCodeNew" clearable maxlength="32"></el-input>
          </el-form-item>
        </el-form>
        <el-progress :percentage="progress" :status="status"></el-progress>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="handleSure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import API from '@/api/masterData/goods';
  export default {
    name: 'merge',
    data() {
      return {
        dialogVisible: false,
        progress: 0,
        status: null,
        propsData: null, // 父组件传递过来的数据
        mergeData: {
          productDetailCodeOld: '', // 原编码
          productDetailCodeNew: '', // 新编码
        },
        mergeDataRules: {
          // 校验规则
          productDetailCodeOld: [{ required: true, message: '请输入原编码', trigger: 'blur' }],
          productDetailCodeNew: [{ required: true, message: '请输入新编码', trigger: 'blur' }],
        },
      };
    },
    methods: {
      openDialog(data) {
        this.status = null;
        this.progress = 0;
        this.dialogVisible = true;
        this.propsData = data;
        this.mergeData.productDetailCodeOld = this.propsData.productDetailCode;
      },
      // 确定
      handleSure() {
        this.progress = 20;
        this.$refs.mergeData.validate((valid) => {
          if (valid) {
            this.$axios.post(API.DETAIL_PRODUCT_MERGE, this.mergeData).then((res) => {
              if (res.data.code === 0) {
                this.progress = 100;
                this.$message({ showClose: true, message: res.data.msg, type: 'success' });
                this.handleClose();
                this.$emit('refreshData');
                this.$parent.$refs.siruiSearch.uploadData();
                let saveChooseClickData = this.$parent.saveChooseClickData[0];
                let newVersion = this.$parent.$refs.siruiSearch
                  .returnTableData()
                  .tableData.filter((item) => {
                    return item.id == saveChooseClickData.id;
                  });
                saveChooseClickData.version = newVersion[0].version + 1;
                saveChooseClickData.detailProductStatus = 'ZT04';
              } else {
                this.$message({ showClose: true, message: res.data.msg, type: 'error' });
                this.status = 'exception';
              }
            });
          }
        });
      },
      handleClose() {
        this.dialogVisible = false;
        this.$refs.mergeData.resetFields();
      },
    },
  };
</script>

<style scoped>
  .merge .container {
    text-align: center;
  }
</style>
